import { render, staticRenderFns } from "./CaratteristicheNew.vue?vue&type=template&id=000908b6&scoped=true&"
import script from "./CaratteristicheNew.vue?vue&type=script&lang=js&"
export * from "./CaratteristicheNew.vue?vue&type=script&lang=js&"
import style0 from "./CaratteristicheNew.vue?vue&type=style&index=0&id=000908b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000908b6",
  null
  
)

export default component.exports